<template>
    <div class="g-searchBox">
        <div class="g-searchTop">
            <img src="../assets/tongwei/back.png" alt="" class="u-back" @click="$router.go(-1)">
            <div class="m-searchInput">
                <img src="../assets/tongwei/searchIcon.png" alt="" class="u-searchIcon" @keyup.enter="searchinit">
                <input type="text" v-model="k" @keyup.enter="searchinit">
                <img src="../assets/tongwei/clean.png" alt="" :class="k.length >0 ?'u-clean' :'u-clean hidden' " @click="k = ''">
            </div>
        </div>

        <div class="u-noData" v-show="isNoData">
            <img src="../assets/tongwei/noData.png" alt="" class="u-noDataImg">
            <p>
                无相关搜索结果，换个关键词试试
            </p>
        </div>


        <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit" :down="{ use: false }" class="g-main"
            v-show="!isNoData">
            <ul class="m-searchList">
                <router-link :to="'/article/' + item.id" tag="li" v-for="(item, index) in dataList" :key="index">
                    <p class="u-title">
                        {{ item.title }}
                    </p>
                    <p class="u-desc">
                        {{ item.summary }}
                    </p>
                    <div class="u-msg">
                        <span>{{ item.published_at }}</span>
                        <span>通威集团</span>
                    </div>
                </router-link>
            </ul>
        </mescroll-vue>
    </div>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";
export default {
    components: {
        MescrollVue
    },
    data() {
        return {
            mescrollUp: {
                callback: this.upCallback,
                auto: false
            },
            mescroll: null,
            page: 0,
            k: '',
            dataList: [],
            isNoData: false
        }
    },
    methods: {

        searchinit() {
            this.dataList = []
            this.page = 0
            this.upCallback()
        },

        upCallback(page, mescroll) {
            this.page = this.page + 1

            this.$axios({
                method: "get",
                url:
                    "/api/articles/search_articles.json?k=" +
                    this.k + '&page=' + this.page,
            }).then(res => {
                console.log(res)
                let arr = res.data.data
                this.dataList = this.dataList.concat(res.data.data)

                if (this.dataList.length == 0) {
                    this.isNoData = true
                } else {
                    this.isNoData = false
                }


                this.$nextTick(() => {
                    mescroll.endSuccess(arr.length)
                })
            })
        },

        mescrollInit(mescroll) {
            this.mescroll = mescroll;
        },
    },
    mounted(params) {
        console.log(this.$route.params.k)
        if (this.$route.params.k) {
            this.k = this.$route.params.k
            this.searchinit()
        }


    }
}
</script>

<style lang="scss">
.g-searchBox {
    padding: .2rem .4267rem;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.u-back {
    width: .4933rem;
    height: .4933rem;
}

.g-searchTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .5333rem;
}

.m-searchInput {
    width: 7.9333rem;
    height: .8rem;
    background: #F3F4F8;
    opacity: 1;
    border-radius: .4rem;
    padding: .2133rem .2933rem .2133rem .4267rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    input {
        background: transparent;
        border: none;
        width: 5.3333rem;

        &:focus {
            outline: 0;
        }
    }
}

.u-searchIcon {
    width: .3733rem;
    height: .3733rem;
}

.u-clean {
    width: .5333rem;
    height: .5333rem;
    &.hidden {
        opacity: 0;
    }
}

.g-main {
    flex: 1;
}

.m-searchList {
    overflow: hidden;

    li {
        padding-bottom: .32rem;
        border-bottom: .0133rem solid #F3F4F8;
        margin-bottom: .32rem;
    }

    .u-title {
        font-size: .4rem;
        color: #333;
        margin-bottom: .2133rem;
    }

    .u-desc {
        color: #666666;
        font-size: .3467rem;
        margin-bottom: .2133rem;
    }

    .u-msg {
        display: flex;
        justify-content: space-between;
        font-size: .3467rem;
        color: #BFBFBF;
    }
}


.u-noData {
    overflow: hidden;
    margin-top: .4rem;

    p {
        color: #999999;
        font-size: .32rem;
        text-align: center;
    }
}

.u-noDataImg {
    width: 5.3333rem;
    height: 4rem;
    display: block;
    margin: 0 auto;
}
</style>